import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" LOGIN ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    action: "/login",
    "label-position": "top",
    method: "POST",
    onSubmit: _ctx.onFormSubmitted
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, "Kundennummer: " + _toDisplayString(_ctx.customerId), 1),
      _createElementVNode("div", null, "Nutzer: " + _toDisplayString(_ctx.username), 1),
      _withDirectives(_createVNode(_component_el_form_item, { label: "Kundennummer" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            id: "cid",
            modelValue: _ctx.customerId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customerId) = $event)),
            modelModifiers: { trim: true },
            name: "cid",
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 512), [
        [_vShow, false]
      ]),
      _withDirectives(_createVNode(_component_el_form_item, { label: "Nutzer" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            id: "username",
            modelValue: _ctx.username,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
            name: "username",
            type: "text"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_el_form_item, { label: "Passwort" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            ref: "passwordInputRef",
            id: "password",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
            modelModifiers: { trim: true },
            name: "password",
            type: "password",
            e2e: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "w-full",
            "native-type": "submit",
            type: "primary",
            disabled: _ctx.store.getState().isLoading
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goBack())),
            class: "w-full",
            type: "secondary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Nicht " + _toDisplayString(_ctx.username) + "? ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}